import Vue from 'vue';

const state = Vue.observable({
  items: JSON.parse(localStorage.getItem('lps_cart') || '[]'),
  drawerOpen: false,
});

function persist() {
  localStorage.setItem('lps_cart', JSON.stringify(state.items));
}

export const cart = {
  get items()      { return state.items; },
  get drawerOpen() { return state.drawerOpen; },
  get count()      { return state.items.reduce((s, i) => s + i.qty, 0); },
  get total()      { return state.items.reduce((s, i) => s + i.price * i.qty, 0); },

  add(product) {
    const existing = state.items.find(i => i.id === product.id);
    if (existing) {
      existing.qty++;
    } else {
      state.items.push({
        id:       product.id,
        title:    product.title,
        duration: product.duration,
        price:    product.price,
        qty:      1,
      });
    }
    persist();
    state.drawerOpen = true;
  },

  remove(productId) {
    const idx = state.items.findIndex(i => i.id === productId);
    if (idx !== -1) state.items.splice(idx, 1);
    persist();
  },

  setQty(productId, qty) {
    if (qty <= 0) { this.remove(productId); return; }
    const item = state.items.find(i => i.id === productId);
    if (item) { item.qty = qty; persist(); }
  },

  clear() {
    state.items.splice(0);
    persist();
  },

  openDrawer()  { state.drawerOpen = true; },
  closeDrawer() { state.drawerOpen = false; },
};
